"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const row_ejs_1 = require("./row.ejs");
const header_ejs_1 = require("./header.ejs");
exports.default = { row: row_ejs_1.default, header: header_ejs_1.default };
